import React from "react";
import {getFontWeight} from "./ShotViewport";
import {Choice, Transformable} from "../../../feature/project/Shot";
import {ConfigChoices} from "../../../feature/project/project";
import {Flex, Image} from "antd";

export const ChoicesElement = (props: {
    editable: boolean,
    choices: Choice[],
    configChoices: ConfigChoices,
    isSelected: boolean,
    scale: number,
    onElementSelected: (choices: Transformable) => void,
    isPlaying: boolean,
    onPlayEnd: (type: string) => void
}) => {

    return (
        <>
            <Flex
                align={'stretch'}
                justify={'center'}
                gap={32}
                wrap={'wrap'}
                style={{
                    zIndex: 10000,
                    width: 800,
                    position: 'absolute',
                }}>
                {props.choices.map((choice, index) => {
                    return (

                        <Flex
                            key={index}
                            align={'center'}
                            justify={'center'}
                            flex={1}
                            style={{
                                minWidth:350,
                                padding: props.configChoices.padding,
                                outline: props.isSelected ? `${2 / (props.scale)}px solid #1890ff` : undefined,
                                borderImageSource: `url(${props.configChoices.background_url})`,
                                borderImageSlice: `${props.configChoices.background_nine_slice_top} ${props.configChoices.background_nine_slice_right} ${props.configChoices.background_nine_slice_bottom} ${props.configChoices.background_nine_slice_left} fill`,
                                borderImageWidth: `${props.configChoices.background_nine_slice_top}px ${props.configChoices.background_nine_slice_right}px ${props.configChoices.background_nine_slice_bottom}px ${props.configChoices.background_nine_slice_left}px`,
                                zIndex: 10000,
                                // height:'100%',
                                transformOrigin: 'top left',
                                cursor: 'pointer',
                            }}
                            onMouseDown={(e) => {
                                e.stopPropagation()
                                if (!props.editable) return
                                props.onElementSelected({type: 'Choice'})
                            }}
                            onClick={(e) => {
                                e.stopPropagation()
                            }}
                        >
                            <div
                                style={{
                                    fontSize: `${props.configChoices.text_font_size}px`,
                                    lineHeight: `${props.configChoices.text_font_size}px`,
                                    color: `${props.configChoices.text_font_color}`,
                                    fontStyle: `${props.configChoices.text_font_style}`,
                                    fontWeight: getFontWeight(props.configChoices.text_font_weight),
                                    whiteSpace: 'pre-line',
                                    textAlign: 'center',
                                }}>

                                {choice.title?.startsWith('http') ? <Image preview={false} src={choice.title} /> : choice.title ?? ''}
                            </div>
                        </Flex>
                    )
                })}
            </Flex>
        </>
    )
}